module.exports = __webpack_public_path__ + "assets/icon_smart_report_highlight.bb3f3799.svg";